import { render, staticRenderFns } from "./salesPerProductsReportList.vue?vue&type=template&id=5a24e188&"
import script from "./salesPerProductsReportList.vue?vue&type=script&lang=js&"
export * from "./salesPerProductsReportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports